import { ResizeGroupBase } from './ResizeGroup.base';

export const ResizeGroup = ResizeGroupBase;
